<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    위험성평가 정보-->
    <vs-row class="mt-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 위험성평가 정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">평가차수</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_1 }}</p>
        <ml-input
          v-else-if="board.readonly"
          v-model="form.inputB_1"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
        <vs-select
          :disabled="board.readonly"
          v-else
          v-model="form.inputB_1"
          autocomplete
          class="w-full flex-1"
        >
          <vs-select-item v-for="index in 99" :key="index" :text="`${index}차`" :value="`${index}차`" />
        </vs-select>
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">실시기간</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputB_2 }} ~ {{ form.inputB_3 }}
        </p>
        <div
          v-else
          class="w-full flex-1"
          style="display: flex; align-items: center"
        >
          <date-selector
            v-model="form.inputB_2"
            :readonly="board.readonly"
            @change="checkDate(form.inputB_2)"
          />
          &nbsp;~&nbsp;
          <date-selector
            v-model="form.inputB_3"
            :readonly="board.readonly"
            @change="checkDate(form.inputB_3)"
          />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">대공정</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_4 }}</p>
        <ml-input
          v-else
          v-model="form.inputB_4"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">중공정</div>
        <p v-if="isPrint" class=" print-input flex-1">{{ form.inputB_5 }}</p>
        <ml-input
          v-else
          v-model="form.inputB_5"
          class="w-full flex-1"
          :readonly="board.readonly"
        />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">예정공정표 첨부</div>
        <p v-if="isPrint" class=" print-input flex-1">
          {{ form.inputB_6.fileName }}
        </p>
        <file-uploader
          :readonly="board.readonly"
          v-else
          v-model="form.inputB_6"
          class="w-full flex-1"
        />
      </div>
    </div>

<!--    위험성 평가표-->
    <table-risk-appraisal-d-h-c-d
      class="mt-5"
      :table-title="'위험성 평가표'"
      :list="form.riskAppraisalList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    />

    <div class="form-group mt-4">
      <div class="overflow-x-auto">
        <div style="background-color: #f9f9f9; text-align: center; padding-top: 10px; padding-bottom: 10px;">
          <feather-icon icon="AlertTriangleIcon" svgClasses="h-4 w-4" class="mr-1" />
          위험성평가
        </div>
        <div class="grid" style="grid-template-columns: 1fr 1fr; border-top: 1px solid #cdcdcd;">
          <div style="padding: 10px;" v-html="leftValue"/>
          <div style="padding: 10px; border-left: 1px solid #cdcdcd;" v-html="rightValue"/>
        </div>
      </div>
    </div>

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!-- 파일첨부 -->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from '@/views/modules/FieldSelectModule'
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader.vue'
import FileUploadModule from '@/views/modules/FileUploadModule'
import TableInspect from '@/components/TableInspect'
import TableInspectDivision from '@/components/TableInspectDivision'
import TableDuration from '../../../../components/TableDuration'
import TableRiskAppraisalDHCD from '@/components/TableRiskAppraisalDHCD'
import PhotoUploadGridModule from '@/views/modules/PhotoUploadGridModule'

export default {
  components: {
    PhotoUploadGridModule,
    TableRiskAppraisalDHCD,
    TableDuration,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        value.summary = {
          // 사업장(공사)명: [],
          // 업체명: [],
        };

        // value.summary["사업장(공사)명"].push({
        //   [this.form.stdInfo.field_name]: 1,
        // });
        //
        // value.summary["업체명"].push({
        //   [this.form.stdInfo.com_name]: 1,
        // });

        this.$emit('input', value)
      },
    },
  },
  methods: {
    checkDate(input) {
      if (Date.parse(this.form.inputB_2) > Date.parse(this.form.inputB_3)) {
        if (input === this.form.inputB_2) {
          this.form.inputB_3 = this.form.inputB_2;
        } else {
          this.form.inputB_2 = this.form.inputB_3;
        }
      }
    },
    updateList(list) {
      this.form.riskAppraisalList = list;
    },
  },
  data () {
    return {
      form: {
        stdInfo: {},

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: {}, // file

        riskAppraisalList: [],
        photoList: [],
        fileList: [],
      },

      leftValue:'※ 위험성평가서 작성(관련규정 : 산업안전보건법 제 36조) <br/>' +
        '빈도(발생가능성) : 높다 (3) / 있다 (2) / 낮다 (1)<br/>' +
        '강도(재해의경중) : 중대재해 등 치명적인 피해 (3) / 휴업재해 등 치료가 필요한 재해 (2) / 경미한재해 (1)<br/>' +
        '위험도 = 빈도 × 강도 의 승산법 적용<br/>' +
        '중점관리 등록 : 위험도 6이상 위험요인에 ○ 표기 <br/>' +
        '　→ 위험성평가 회의록 주요위험요인에 기록관리 <br/>' +
        '　→ 관리감독자는 작업허가서 위험요인에 기록 이행실태를 주간단위 확인기록 <br/>' +
        '　→ 안전관리자는 순회점검일지에 대책이행 여부 기록관리 <br/>' +
        '작성자(협력사)의 위험요인에 기록되지 않은 추가위험요인은 검토과정에서 별도작성 첨부',
      rightValue:'※ 실시결과에 따른 재개선 활동 <br/>' +
        '당회차 위험성평가결과 개선 및 대책이 미흡한 유해·위험요인은 차회 차의 위험성평가에 추가 위험요인으로 FeedBack 관리 <br/>' +
        '※ 위험성평가 실시 주기 <br/>' +
        '2주 단위 위험성평가 실시 <br/>' +
        '※ 위험성평가시 근로자 참여 <br/>' +
        '※ 기록관리<br/>' +
        '위험성평가서 실시자료는 3년간 보존(시행규직 제 37조)',
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
